import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensureUser } from '../lib/auth/guards';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const user = await ensureUser(context.queryClient);
    throw redirect({ to: user ? '/dashboard' : '/login' });
  },
});
